import React, {useState} from 'react';
import CopilotButton from './CopilotButton';
import CopilotPanel from './CopilotPanel';
import {usePortal} from '../hooks/usePortal';
import AppConstants from '../Constants/AppConstants';

const Copilot = ({isExpand}) => {
  const [isOpen, setIsOpen] = useState(false);
  const portal = usePortal();

  const handleOpen = () => setIsOpen(true);
  const handleClose = () => setIsOpen(false);

  return (
    <div className="w-full max-w-[240px]">
      {<CopilotButton onClick={handleOpen} isExpand={isExpand} />}
      {portal.render(<CopilotPanel isOpen={isOpen} onClose={handleClose} />)}
    </div>
  );
};

export default Copilot;
